const ITEMS = [
  "CBSE • ICSE • IGCSE • IB • State Boards",
  "Class 1st to 12th + Foundation",
  "2 Free Demo Lectures (1 Hour Each)",
  "Easy Teacher Replacement Guarantee",
  "Experienced Mentors & Energetic Young Faculty",
  "1-on-1 Student Career Counselling",
  "Pan-India Remote Area Coverage",
  "Trusted Since 2016",
];

function Row({ hidden }) {
  return (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap px-6 font-mono text-[11px] uppercase tracking-[0.22em] text-navy-dark/70 sm:px-10 sm:text-xs">
            {item}
          </span>
          <span className="h-1.5 w-1.5 rotate-45 bg-gold" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-navy/10 bg-white py-4"
    >
      <div className="flex w-max animate-m2-marquee">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
